import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "background-image" }, null, -1)
const _hoisted_2 = {
  id: "did-header",
  class: "white"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "didriksons-logotype white" }, null, -1)
const _hoisted_4 = { class: "materialbank-text" }
const _hoisted_5 = { class: "_login" }
const _hoisted_6 = { class: "_login-container vueLogin" }
const _hoisted_7 = {
  class: "_login-label",
  for: "username"
}
const _hoisted_8 = {
  class: "_login-label",
  for: "password"
}
const _hoisted_9 = { class: "terms" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "terms"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_12 = { class: "terms-text" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "_login-validation"
}

import { invokeKey, navigateKey } from '@drapejs/core';
import {
  computed, inject, ref, watch,
} from 'vue';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { frameworkContentKey, litiumKey } from '@/keys';
import * as media from '../commands/media';
import useContext from '@/composables/useContext';
import useMeta from '@/composables/useMeta';


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const invoke = inject(invokeKey);

const {
  page,
} = useContext();

const username = ref('');
const password = ref('');

const errorMessage = ref<string | null>(null);

const litium = inject(litiumKey);

const { websiteText } = useWebsiteTexts();

const frameworkContent = inject(frameworkContentKey);

async function login() {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const result = await invoke!(media.commands.login, {
    url: window.location.href,
    username: username.value,
    password: password.value,
  });

  if (result.message) {
    errorMessage.value = result.message;
  }
}

const isLoggedIn = computed(() => litium?.value?.uid && litium?.value?.uid !== 'NotAuthenticated');
const navigate = inject(navigateKey);
watch(isLoggedIn,
  (didLogIn) => {
    const materialBankPagePath = frameworkContent?.value.MaterialBankPage?.href;
    if (didLogIn && materialBankPagePath) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      navigate!(materialBankPagePath);
    }
  }, { immediate: true });

useMeta();

return (_ctx: any,_cache: any) => {
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(websiteText)('material_bank_page_caption').value), 1)
    ]),
    _createVNode(_component_blocks_repeater, {
      blocks: _unref(page)?.blocks?.Header
    }, null, 8, ["blocks"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(websiteText)('login_username').value), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "username",
          name: "username",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (login()), ["enter"]))
        }, null, 544), [
          [_vModelText, username.value]
        ]),
        _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(websiteText)('login_password').value), 1),
        _withDirectives(_createElementVNode("input", {
          type: "password",
          id: "password",
          name: "password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (login()), ["enter"]))
        }, null, 544), [
          [_vModelText, password.value]
        ]),
        _createElementVNode("label", _hoisted_9, [
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(websiteText)('material_bank_terms_and_conditions').value), 1)
        ]),
        _createElementVNode("button", {
          class: "_login-button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (login())),
          disabled: username.value === '' || password.value === ''
        }, _toDisplayString(_unref(websiteText)('login_login').value), 9, _hoisted_13),
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_blocks_repeater, {
      blocks: _unref(page)?.blocks?.Footer
    }, null, 8, ["blocks"])
  ], 64))
}
}

})